/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { checkGuaranteedItemAsync } from '../actions/DataActionExtension.g';
import { generateCacheKey, getSelectedProductIdFromActionInput } from '@msdyn365-commerce-modules/retail-actions';
// import { IGuaranteedItemResponse } from '../actions/DataServiceEntities.g';

/**
 * CheckGuaranteedItem Input Action
 */
export class CheckGuaranteedItemInput implements Msdyn365.IActionInput {
    public productId: number;
    public apiSettings: Msdyn365.ICommerceApiSettings;
    constructor(productId: number, apiSettings: Msdyn365.ICommerceApiSettings) {
        this.productId = productId;
        this.apiSettings = apiSettings;
    }

    public getCacheKey = () => generateCacheKey(this.apiSettings, { key: 'productId', value: `${this.productId}` });
    public getCacheObjectType = () => 'guaranteedItem';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ICheckGuaranteedItemData {
    isGuaranteedItem: boolean;
}

const createCheckGuaranteedItemInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const context = args.requestContext;
    const appSettings = context.apiSettings;
    const productId = getSelectedProductIdFromActionInput(args);
    if (productId) {
        return new CheckGuaranteedItemInput(parseInt(productId, 10), appSettings);
    }
    throw Error('Unable to create CheckGuaranteedItemInput, no productId found in the URL');
};

async function action(input: CheckGuaranteedItemInput, ctx: Msdyn365.IActionContext): Promise<ICheckGuaranteedItemData> {
    const res = await checkGuaranteedItemAsync({ callerContext: ctx }, input.productId);
    if (res) {
        return { isGuaranteedItem: res.IsGuaranteed || false };
    }

    throw new Error('Unable to get product');
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICheckGuaranteedItemData>>action,
    id: 'CheckGuaranteedItem',
    input: createCheckGuaranteedItemInput
});
